export default "__VITE_IMAGE_ASSET__da60f661__";